import React from 'react'
import { TextStyles } from 'styles/style';
import PdfViewer from "helpers/PdfViewer.js";

const PdfContent = ({
    file,
    contents
 }) => {
  return (
    <TextStyles.Text>
        <PdfViewer pdf={
            {
                file: file ? `https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/${file}.pdf` : "",
            }
        }
        />
    </TextStyles.Text>
  )
}

export default PdfContent